import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/shared/services/config.service';
import { first, map } from '@totvs/mingle/node_modules/rxjs/operators';
import { TokenService } from '../token/token.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private configService: ConfigService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean |
  UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {
    const valid = this.tokenService.hasToken();

    if (!valid) {
      this.router.navigate(['/login']);
    }
    return this.configService.preLoad().pipe(first(), map(() => true )).toPromise().then(() => true);
  }
}
